import { OrderStatus } from '@dreryk/egabinet-statistics-frontend-api';

import { statisticsTranslationKeys } from '../../../translations';

export const getStatusLabel = (status: OrderStatus): string => {
   switch (status) {
      case 'READY':
         return statisticsTranslationKeys.orderTable.statusComponent.READY;
      case 'IN_PROGRESS':
         return statisticsTranslationKeys.orderTable.statusComponent.IN_PROGRESS;
      default:
         return statisticsTranslationKeys.orderTable.statusComponent.FAILED;
   }
};
